module.exports = __webpack_public_path__ + "media/src/images/icons/photo_icon_small-38d20bb5732722a17bb4b83881973379.svg";